// Shared value→label maps for plan pills and tags (Plans page cards/filters + PlanEditModal header)
export const PLAN_TYPE_PILL_LABELS = { business: 'Business', agency: 'Agency', doneForYou: 'Done For You', credits: 'Credits' };
export const INTERVAL_PILL_LABELS = { day: 'Daily', week: 'Weekly', month: 'Monthly', quarter: 'Quarterly', year: 'Yearly', lifetime: 'Lifetime' };
